import React, { useState, useRef, useEffect } from 'react';
import '../styles/Menu.css';

const Menu = ({ onAboutClick, onFAQsClick, onContactClick }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleAboutClick = () => {
        onAboutClick();
        setIsOpen(false);
    };

    const handleFAQsClick = () => {
        onFAQsClick();
        setIsOpen(false);
    };

    const handleContactClick = () => {
        onContactClick();
        setIsOpen(false);
    };

    const handleMenuItemClick = (url) => {
        window.open(url, '_blank');
        setIsOpen(false);
    };

    return (
        <div className="menu-container" ref={menuRef}>
            <button className="menu-button" onClick={toggleMenu} title="Menu">
                Menu
            </button>
            {isOpen && (
                <div className="menu-dropdown">
                    <button 
                        className="menu-item" 
                        onClick={() => handleMenuItemClick('/about.html')}
                    >
                        About CLIP AND GO
                    </button>
                    <button 
                        className="menu-item" 
                        onClick={handleFAQsClick}
                    >
                        FAQs
                    </button>
                    <button 
                        className="menu-item" 
                        onClick={() => handleMenuItemClick('https://buymeacoffee.com/inklab')}
                    >
                        Support Us
                    </button>                    
                    <button 
                        className="menu-item" 
                        onClick={handleContactClick}
                    >
                        Contact Us
                    </button>
                </div>
            )}
        </div>
    );
};

export default Menu;
